<div
  class="video-profile-cell"
  [class.clickable]="clickable">
  <span class="video-profile-cell__badge">{{ profileLabel }}</span>
  <span
    class="video-profile-cell__thumbtack"
    *ngIf="pinned"></span>

  <div class="video-profile-cell__group">Video Encoder Control</div>
  <div class="video-profile-cell__row">
    <span class="video-profile-cell__label">Exterior:</span>
    <span class="video-profile-cell__code">{{ encoderExterior }}</span>
  </div>
  <div class="video-profile-cell__row">
    <span class="video-profile-cell__label">Interior:</span>
    <span class="video-profile-cell__code">{{ encoderInterior }}</span>
  </div>

  <div class="video-profile-cell__group">Video Source Control</div>
  <div class="video-profile-cell__row">
    <span class="video-profile-cell__label">Exterior:</span>
    <span class="video-profile-cell__code">{{ sourceExterior }}</span>
  </div>
  <div class="video-profile-cell__row">
    <span class="video-profile-cell__label">Interior:</span>
    <span class="video-profile-cell__code">{{ sourceInterior }}</span>
  </div>
</div>
